module.exports = __webpack_public_path__ + "static/img/female-bg-id.b39a6356.png";